import "./loading-spinner.css";

import { Loader } from "@tql/ui-components-react/kendo/indicators";

type LoadingSpinnerProps = {
	readonly isVisible?: boolean;
};

export function LoadingSpinner({ isVisible = true }: LoadingSpinnerProps) {
	if (!isVisible) {
		return null;
	}

	return (
		<>
			<div className={"loading-overlay"} data-testid={"loading-overlay"}></div>
			<div className={"loader-content"} data-testid={"loading-spinner"}>
				<Loader size={"large"} type={"infinite-spinner"} />
			</div>
		</>
	);
}
